module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/redux-api-middleware/~/babel-runtime/core-js/object/assign.js
// module id = 1883
// module chunks = 0